import { defineComponent as _defineComponent } from 'vue'
import Legal from '@/components/legal';
import useFileWrapperMultiView from '../../composables/use-file-wrapper-multi-view';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiViewInfo',
  setup(__props) {

const { patentHeaderInfo } = useFileWrapperMultiView();


return { __sfc: true,patentHeaderInfo, Legal }
}

})